var _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
var SvgTiktok = function SvgTiktok(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 27,
    height: 31,
    fill: "none",
    className: "social-link"
  }, props), _g || (_g = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    fill: "currentColor",
    d: "M26.7834 12.927a12.3078 12.3078 0 0 1-7.1933-2.2997v10.4716a9.5247 9.5247 0 0 1-6.187 8.9169A9.524 9.524 0 0 1 1.6899 16.5619a9.5243 9.5243 0 0 1 9.6838-4.9005v5.2669a4.3722 4.3722 0 1 0 3.0603 4.1706V.6279h5.1561a7.1058 7.1058 0 0 0 .1089 1.299 7.158 7.158 0 0 0 3.1587 4.7003 7.115 7.115 0 0 0 3.9257 1.18v5.1198Z"
  }))));
};
export default SvgTiktok;